import { EnumSchema } from '../metadata-schema';

export const OnderwijspositieStatus: EnumSchema = {
	"type": "string",
	"title": "OnderwijspositieStatus",
	"enum": [
		"Informatie volledig",
		"Opleiding voor lj3 niet correct in systeem",
		"Advies niet correct in systeem",
		"Examenstatus niet correct in systeem",
		"(Advies)plaatsing volgend schooljaar nog niet bekend",
		"Doorstroom niet af te leiden uit vertrekstatus",
		"Onbekende doorstroom",
		"Doorstroom kan door onbekende oorzaak niet worden bepaald",
		"Uitstroom naar onbekend niveau"
	]
};
